import TranslationNS from '@/utils/Constants/TranslationNS'
import { closeAdvancedSearch, openAdvancedSearch } from '@/utils/advancedSearchStore'

const HOME = TranslationNS.HOME_PAGE

/**
 * The home page tour (William, 29 Oct 2026: « une visite guidée de la page d'accueil du site en
 * expliquant également le système de recherche »): the search field of the navbar, the advanced
 * filters (the step opens the panel and closes it again), the discipline chips, list / map, « Create an
 * Event », then the first event card. A site tour on an absolute route: played by the site host, offered
 * to every visitor (logged in or not), replayed from the account menu.
 */
export const HOME_TOUR = {
    id: 'home',
    version: 1,
    routes: ['/'],
    steps: [
        {
            key: 'search',
            target: '[data-tour="nav-search"]',
            placement: 'bottom',
            title: 'Find an event',
            description:
                'Type the name of an event: the list filters while you write. Clicking in the field opens the advanced filters under the bar.',
        },
        {
            key: 'advanced',
            target: '[data-tour="home-advanced"]',
            assumeTarget: true,
            enter: openAdvancedSearch,
            leave: closeAdvancedSearch,
            // on a phone the panel stacks its four fields (≈ 500 px): under the nav, bubble below it,
            // without the entry lines (the field labels are on screen anyway)
            scroll: 'start',
            entriesDesktopOnly: true,
            placement: 'bottom',
            title: 'Refine the search',
            description: 'Each filter applies at once; « Reset » clears them all, « Search » closes the panel.',
            entries: [
                { label: 'Event type', ns: HOME, text: 'functional fitness, hybrid race or workshop.' },
                { label: 'Divisions', ns: HOME, text: 'individual or team events.' },
                { label: 'Month', ns: HOME, text: 'events taking place that month.' },
                { label: 'Country', ns: HOME, text: 'type to find yours.' },
                { label: 'Opened registrations', ns: HOME, text: 'only the events you can still register for.' },
            ],
        },
        {
            key: 'categories',
            target: '[data-tour="home-categories"]',
            placement: 'bottom',
            placementNarrow: 'bottomLeft',
            title: 'By discipline',
            description: 'One click on a discipline keeps only its events; a second click removes the filter.',
        },
        {
            key: 'view',
            target: '[data-tour="home-view"]',
            placement: 'bottom',
            placementNarrow: 'top',
            title: 'List or map',
            description:
                'The map shows the same events around the world; click a marker to open the event. The filters apply to both views.',
        },
        {
            key: 'create',
            target: '[data-tour="home-create"]',
            placement: 'bottom',
            title: 'Create your own event',
            description:
                'You organize a competition? This button creates its page in a few questions (you will be asked to log in first).',
        },
        {
            key: 'cards',
            target: '[data-tour="home-cards"] > a:first-child',
            placement: 'bottom',
            placementNarrow: 'top',
            title: 'Each event at a glance',
            description:
                'Date, place, discipline and above all the registration status: open, opens on a date, closed or sold out. Click the card to open the event page.',
        },
    ],
}

export default HOME_TOUR
